import React from 'react';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import { Box, type SvgIconProps } from '@mui/material';
import { INBOX_THEME } from '../../pages/Inbox/inboxTheme';
import { assistantLogoRoundedWrapSx } from './assistantTheme';

/** Ícone da Central de suporte — ajuda humana (distinto do atendente `SupportAgent`). */
const SupportCenterIcon: React.FC<SvgIconProps> = (props) => <HandshakeOutlinedIcon {...props} />;

/** Selo do cabeçalho do painel (SVG embutido — não depende de PNG/CDN). */
export function SupportCenterHeaderBadge({ size = 32 }: { size?: number }) {
  const iconSize = Math.max(16, Math.round(size * 0.56));
  return (
    <Box sx={assistantLogoRoundedWrapSx(size)} aria-hidden>
      <SupportCenterIcon sx={{ fontSize: iconSize, color: INBOX_THEME.tealDark }} />
    </Box>
  );
}

export default SupportCenterIcon;
